import lazyLoad from 'app/shared-components/util/lazyLoad';

const AIChat = lazyLoad(() => import('./chat/AIChat'));
const AIChatFirstScreen = lazyLoad(() => import('./AIChatFirstScreen'));
const EmailInboxChat = lazyLoad(() => import('./chat/EmailInboxChat'));
const EmailInboxFirstScreen = lazyLoad(() => import('./EmailInboxFirstScreen'));
const AIChatApp = lazyLoad(() => import('./AIChatApp'));

const AIChatAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  helpConfig: {
    query: 'AI',
    tag: 'ai-agent',
    title: 'AI Assistant'
  },
  routes: [
    {
      path: 'apps/ai-chat',
      element: <AIChatApp />,
      children: [
        {
          path: '',
          element: <AIChatFirstScreen />,
        },
        {
          path: ':id',
          element: <AIChat />,
        },
      ],
    },
    {
      path: 'apps/agent-inbox',
      element: <AIChatApp />,
      children: [
        {
          path: '',
          element: <EmailInboxFirstScreen />,
        },
        {
          path: ':id',
          element: <EmailInboxChat />,
        },
      ],
    },
  ],
};

export default AIChatAppConfig;